export class GovernmentCompanyAdditionalInfo {
    jbkjs: string;
    contractId: string;
    contractDate: Date | null;
  
    constructor(data: any) {
      this.jbkjs = data.jbkjs || '';
      this.contractId = data.contractId || '';
      this.contractDate = data.contractDate || null;
    }
  }